import { IProject } from "apps/decooda/components/projects/projectCard.types";
import { IProjectIQWorkspace } from "models/IProjectIQWorkspace";

export type CreateAnalyticsStep = "basic-info" | "data";

export interface ICreateAnalyticsDialogProps {
  isOpen: boolean;
  workspaceId: string;
  workspace: IProjectIQWorkspace;
  onDismiss: () => void;
  onSaved?: () => void;
  mode?: "create" | "edit";
  project?: IProject;
  diagnosticId?: string;
  onCreated?: (projectId: string) => void;
}

export interface IPendingAttachment {
  id: string;
  file: File;
  delimiter: string;
  columns: string[];
  contentColumn: string;
  isUploading: boolean;
  sheetNames: string[];
  selectedSheet: string;
}

export const STEP_LABELS: Record<CreateAnalyticsStep, string> = {
  "basic-info": "Basic Info",
  data: "Data",
};

export const DIALOG_LABELS = {
  TITLE: "New Analytics Project",
  TITLE_EDIT: "Edit Analytics Project",
  CLOSE: "Close",
  BACK: "Back",
  NEXT: "Next",
  NEXT_DISABLED: "Next (complete the current step first)",
  SUBMIT_LABEL: "Create project",
  SUBMIT_LABEL_EDIT: "Save changes",
  SUBMIT_LABEL_DISABLED: "Create project (add at least one data file)",
  SUBMIT_LABEL_EDIT_DISABLED: "Save changes (add at least one data file)",
  SAVING: "Creating analytics project",
  SAVING_EDIT: "Saving changes",
  NAME_LABEL: "Analytics Name",
  NAME_PLACEHOLDER: "Enter analytics name...",
  NAME_REQUIRED: "Analytics Name is required.",
  OBJECTIVE_LABEL: "Objective (optional)",
  OBJECTIVE_PLACEHOLDER: "Describe the objective of this analysis...",
  WORKSPACE_SECTION_LABEL: "From this workspace",
  WORKSPACE_LABEL: "Workspace",
  CLIENT_NAME_LABEL: "Client Name",
  CLIENT_NAME_PLACEHOLDER: "Enter client name",
  WORKDAY_CODE_LABEL: "Project Workday Code",
  WORKDAY_CODE_PLACEHOLDER: "Enter Workday code",
  DATA_INFO_BANNER:
    "All uploaded data stays inside this workspace and is available as context throughout Project IQ.",
  ERROR_CREATE: "Failed to create analytics project. Please try again.",
  ERROR_UPDATE: "Failed to update analytics project. Please try again.",
  PREFILLED: "Pre-filled",
} as const;
